export const GET_REVIEWS_LIST = null;
export const SELECTED_REVIEW_ID = null;
export const GET_SERVICE_PROVIDER_REVIEWS_LIST = null;
export const SELECTED_SERVICE_PROVIDER_REVIEW_INFO_DETAILS = null;